import React from 'react'
import './about.css'
import ME from '../../assets/Michael_Drawing.png'

const About = () => {
  return (
    <section id='about'>
      <h5>Get to Know</h5>
      <h2>About Me</h2>

      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>
        <p>
        A front-end developer based in Diamond Bar, California. My journey started with Neopets and Myspace as a kid but I decided to refine my skills in 2020 when my son was born. I love watching movies and playing video games.
        </p>
      </div>
    </section>
  )
}

export default About